module.exports = __webpack_public_path__ + "img/renkei_on.eee7488a.png";